export enum BehavioralThumbnailType {
    Job,
    Person
}
